"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 6.7A3.7 3.7 0 0 1 6.7 3h6.602a3.7 3.7 0 0 1 3.7 3.7V8a.7.7 0 1 1-1.4 0v-.45H4.4v5.752a2.3 2.3 0 0 0 2.3 2.3h3.05a.7.7 0 1 1 0 1.4H6.7a3.7 3.7 0 0 1-3.7-3.7zm1.466-.55h11.07a2.3 2.3 0 0 0-2.234-1.75H6.7a2.3 2.3 0 0 0-2.234 1.75",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.494 9.754a.7.7 0 0 1 .002.99l-2.48 2.489a.7.7 0 0 1-.992 0l-1.52-1.526a.7.7 0 1 1 .992-.988l1.024 1.028 1.984-1.991a.7.7 0 0 1 .99-.002",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.48 10.157a1.904 1.904 0 1 1 2.693 2.693l-3.623 3.624a1.2 1.2 0 0 1-.708.343l-1.13.134a1.2 1.2 0 0 1-1.333-1.333l.134-1.13a1.2 1.2 0 0 1 .343-.708zm1.703.99a.505.505 0 0 0-.713 0l-3.575 3.574-.095.81.809-.096 3.574-3.575a.505.505 0 0 0 0-.713",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CalendarWithPencilIcon20.js.map